module.exports = __webpack_public_path__ + "img/charging.e8aadbfc.gif";